import * as React from 'react';
export var ActivityIndicatorSize;
(function (ActivityIndicatorSize) {
    ActivityIndicatorSize["Normal"] = "w-12 h-12";
    ActivityIndicatorSize["Small"] = "w-8 h-8";
})(ActivityIndicatorSize || (ActivityIndicatorSize = {}));
export var ActivityIndicator = function (_a) {
    var containerStyle = _a.containerStyle, _b = _a.size, size = _b === void 0 ? ActivityIndicatorSize.Normal : _b;
    return (<div className={containerStyle !== undefined ? containerStyle : 'container mx-auto flex justify-center items-center my-16'}>
		<div className={"loader ease-linear rounded-full border-4 border-t-4 ".concat(size.valueOf())}/>
	</div>);
};
ActivityIndicator.displayName = 'UI.ActivityIndicator';
